export default "__VITE_ASSET__Bt1gDncG__"